<app-layout>
  <mat-card>
    <mat-card-title class="header">
      <h5>Create Blank Report</h5>
    </mat-card-title>

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()" class="report-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Report Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter report name" />
          <mat-error *ngIf="form.get('name')?.hasError('required')">
            Report name is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Report Type</mat-label>
          <mat-select formControlName="reportTypeId">
            <mat-option *ngFor="let option of reportTypes" [value]="option.id">
              {{ option.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('reportTypeId')?.hasError('required')">
            Report type is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Data Source</mat-label>
          <mat-select formControlName="reportDataSourceId">
            <mat-option *ngFor="let option of reportDataSources" [value]="option.id">
              {{ option.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('reportDataSourceId')?.hasError('required')">
            Data source is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Culture</mat-label>
          <mat-select formControlName="cultureId">
            <mat-option *ngFor="let option of cultures" [value]="option.id">
              {{ option.text }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('cultureId')?.hasError('required')">
            Culture is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" rows="4" placeholder="Optional description"></textarea>
        </mat-form-field>

        <div class="actions">
          <button mat-stroked-button type="button" (click)="cancel()">
            Cancel
          </button>

          <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
            Create Report
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</app-layout>